import React, { lazy, Suspense } from "react";
import { Spin, Result, theme } from "antd";
import { FileUnknownOutlined } from "@ant-design/icons";

const ACTION_MAP = {
    flip_image: lazy(() => import("./actions/FlipImage")),
    compress_image_to_size: lazy(() => import("./actions/CompressImageToSize")),
    jpg_to_png: lazy(() => import("./actions/JpgToPng")),
    png_to_jpg: lazy(() => import("./actions/PngToJpg")),
    png_to_webp: lazy(() => import("./actions/PngToWebp")),
    jpg_to_webp: lazy(() => import("./actions/JpgToWebp")),
    webp_to_png: lazy(() => import("./actions/WebpToPng")),
    webp_to_jpg: lazy(() => import("./actions/WebpToJpg")),
    resize_image_by_percentage: lazy(() => import("./actions/ResizeImageByPercentage")),
    crop_image_manually: lazy(() => import("./actions/CropImageManually")),
    apply_blur: lazy(() => import("./actions/ApplyBlur")),
    sharpen_image: lazy(() => import("./actions/SharpenImage")),
    adjust_brightness_contrast: lazy(() => import("./actions/AdjustBrightnessContrast")),
    adjust_saturation_hue: lazy(() => import("./actions/AdjustSaturationHue")),
    convert_to_grayscale: lazy(() => import("./actions/ConvertToGrayscale")),
    add_watermark: lazy(() => import("./actions/AddWatermark")),
    add_border: lazy(() => import("./actions/AddBorder")),
    extract_exif_metadata: lazy(() => import("./actions/ExtractExifMetadata")),
    strip_exif_metadata: lazy(() => import("./actions/StripExifMetadata")),
    rotate_image: lazy(() => import("./actions/RotateImage")),
    zip_files: lazy(() => import("./actions/ZipFiles")),
    unzip_file: lazy(() => import("./actions/UnzipFile")),
    unlock_pdf: lazy(() => import("./actions/UnlockPdf")),
    merge_pdfs: lazy(() => import("./actions/MergePdfs")),
};

function FileMasterNew({ data }) {
    const action = data?.data?.action;
    const ActionComponent = ACTION_MAP[action];
    const { token } = theme.useToken();

    if (!ActionComponent) {
        return (
            <Result
                icon={<FileUnknownOutlined style={{ color: token.colorTextQuaternary }} />}
                title="Unknown Action"
                subTitle={
                    action
                        ? `"${action}" is not supported.`
                        : "No action specified."
                }
                style={{ padding: "24px 0" }}
            />
        );
    }

    return (
        <Suspense
            fallback={
                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: 40,
                    }}
                >
                    <Spin size="large" />
                </div>
            }
        >
            <ActionComponent data={data} />
        </Suspense>
    );
}

export default FileMasterNew;
